import { withUnmountTransition } from '../../../../misc/withUnmountTransition.hoc'
import { EditQuestionInstanceBottomPanel } from './EditQuestionInstancePanel.component'

const withUnmountHoc = withUnmountTransition(EditQuestionInstanceBottomPanel)
export { withUnmountHoc as EditQuestionInstanceBottomPanel }
